export const WAIT_BRIDGE_ARM_DELAY_MS = (() => {
  const raw = Number(process.env.REACT_APP_VH_WAIT_BRIDGE_ARM_DELAY_MS);
  return Number.isFinite(raw) && raw > 0 ? raw : 1500;
})();

export const WAIT_BRIDGE_TIMEOUT_MS = (() => {
  const raw = Number(process.env.REACT_APP_VH_WAIT_BRIDGE_TIMEOUT_MS);
  return Number.isFinite(raw) && raw > 0 ? raw : 10000;
})();

export function logWaitBridge(event, payload = {}) {
  if (String(process.env.REACT_APP_VH_WAIT_BRIDGE_DEBUG || "0") !== "1") return;
  const safeEvent = String(event || "").trim();
  if (!safeEvent) return;
  try {
    // eslint-disable-next-line no-console
    console.log(`[${safeEvent}]`, payload || {});
  } catch {}
}

export function isWaitBridgeEnabled() {
  return String(process.env.REACT_APP_VH_WAIT_BRIDGE_ENABLE || "1") !== "0";
}

function buildFallback(requestId, reason = "error") {
  return {
    available: false,
    request_id: String(requestId || "").trim(),
    bridge_text: "",
    reason: String(reason || "error"),
  };
}

export async function fetchWaitBridge({
  apiBaseUrl,
  requestId,
  question,
  lang,
  modeHint,
  signal,
}) {
  const rid = String(requestId || "").trim();
  const root = String(apiBaseUrl || "").replace(/\/$/, "");
  const url = `${root}/api/wait-bridge`;

  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(new DOMException("Wait bridge timeout", "TimeoutError")), WAIT_BRIDGE_TIMEOUT_MS);
  const relayAbort = () => controller.abort();
  if (signal && typeof signal.addEventListener === "function") {
    signal.addEventListener("abort", relayAbort, { once: true });
  }

  try {
    const res = await fetch(url, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        request_id: rid,
        question: String(question || ""),
        lang: String(lang || "pt"),
        mode_hint: String(modeHint || ""),
        final_pending: true,
      }),
      signal: controller.signal,
    });
    if (!res.ok) return buildFallback(rid, "error");
    const parsed = await res.json();
    if (!parsed || typeof parsed !== "object") return buildFallback(rid, "error");
    return {
      available: parsed.available === true,
      request_id: String(parsed.request_id || rid).trim(),
      bridge_text: String(parsed.bridge_text || "").trim(),
      reason: String(parsed.reason || "").trim() || "error",
    };
  } finally {
    clearTimeout(timeout);
    if (signal && typeof signal.removeEventListener === "function") {
      signal.removeEventListener("abort", relayAbort);
    }
  }
}

export function shouldRenderWaitBridge(bridgeState, currentTurnRequestId) {
  return Boolean(
    bridgeState
      && bridgeState.available === true
      && String(bridgeState.bridge_text || "").trim()
      && String(bridgeState.requestId || "").trim() === String(currentTurnRequestId || "").trim()
  );
}

